import { createApi } from '@reduxjs/toolkit/query/react';
import { serviceBaseQuery } from './baseQuery';

export const apiTagTypes = [
    'Asset',
    'AssetList',
    'AssetAssociations',
    'Association',
    'AssetTags',
    'Tag',
    'TagList',
    'DeviceSharings',
    'Contracts',
] as const;

export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery: serviceBaseQuery,
    tagTypes: apiTagTypes,
    endpoints: () => ({}),
});
